import Accordion from '@nib-components/accordion';
import Alert from '@nib-components/alert';
import Heading from '@nib-components/heading';
import Section from '@nib-components/section';
import {Stack} from '@nib/layout';
import React, {useEffect} from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import {getCallForHelpContent} from '../data/callForHelpContent';
import {getCommonSectionsForBrand} from '../data/getCommonSectionsForBrand';
import {getExtraNibSections} from '../data/getExtraNibSections';
import {tealiumWrapper} from '../util/TealiumWrapper';

const TextCenter = styled.div`
  text-align: center;
`;

const generateAccordian = (brand, onBeforeExpand, onBeforeCollapse, clickHandler) => {
  return (
    <Accordion>
      {getExtraNibSections(brand, clickHandler).map((item) => (
        <Accordion.Item {...item} onBeforeExpand={() => onBeforeExpand(item.title)} onBeforeCollapse={() => onBeforeCollapse(item.title)}></Accordion.Item>
      ))}
      {getCommonSectionsForBrand(brand).map((item) => {
        return item.children ? <Accordion.Item {...item} onBeforeExpand={() => onBeforeExpand(item.title)} onBeforeCollapse={() => onBeforeCollapse(item.title)}></Accordion.Item> : <div />;
      })}
    </Accordion>
  );
};

const NeedSomeHelp = (props) => {
  const {tealiumTrack, tealiumPageView} = tealiumWrapper();
  const brandConfig = props.pageContext.brand;

  useEffect(() => {
    tealiumPageView('page_view', {
      channel: 'Online',
      site_name: process.env.PUBLIC_DOMAIN || 'id.nib.com.au',
      site_section: 'online_services',
      page_name: 'need-help-landing-page',
      page_type: 'online_services',
    });
  }, []);

  const onBeforeExpand = (title) => {
    tealiumTrack('expand_help_item', {title});
  };

  const onBeforeCollapse = (title) => {
    tealiumTrack('collapse_help_item', {title});
  };

  const clickHandler = (link, eventName) => {
    tealiumTrack(eventName, {link});
    window.open(link, '_blank');
  };

  return (
    <Layout {...props.pageContext}>
      <Section>
        <Stack space={{xs: 5, md: 7}}>
          <TextCenter>
            <Heading size={1}>Need help logging in?</Heading>
          </TextCenter>

          {generateAccordian(brandConfig, onBeforeExpand, onBeforeCollapse, clickHandler)}

          {getCallForHelpContent(brandConfig, tealiumTrack)}

          <Alert type="info" title="Once you're in..." fullWidth={false}>
            When you’re logged into your member account, it’s a good idea to check your personal and contact details are correct and up-to-date. If there’s more than one person on your cover, we also
            recommend adding an individual email address or phone number for each policy member. This means that each member can have their own member account, and will be able to log in to view and
            manage their cover.
          </Alert>
        </Stack>
      </Section>
    </Layout>
  );
};

export default NeedSomeHelp;
